// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__15xyA","footer":"ReportModalFilter_footer__1KotG"};